import React from "react";
import { Link } from "react-router-dom";

const SingleForum = ({ forum }) => {

  return (
    <div
      className="bg-white py-4  px-3 mt-5 d-flex flex-column align-items-center justify-content-center"
      style={{ width: "100%" }}
    >
      <p>
       <strong>{forum.title}</strong>

      </p>
      <small
        className="text-center text-secondary mt-2 mb-1 py-3"
        style={{ fontWeight: "300" }}
        dangerouslySetInnerHTML={{
          __html: forum?.data.substring(0, 150).split(" ").slice(0, -1).join(" ") +
              "...",
        }}
      />

      <hr />

      <div
        className="d-flex align-items-center justify-content-between px-2"
        style={{ width: "100%" }}
      >
        <div className="mx-1 d-flex align-items-center justify-content-between">
          <span className="mx-1 " style={{ color: "#f38e35" }}>
            <i class="bi bi-calendar"></i>
          </span>
          <small className="mx-2">{forum.createdAt.split("T")[0]}</small>
          <span className="mx-1 " style={{ color: "#f38e35" }}>
            <i class="bi bi-eye"></i>
          </span>
          <small>{forum.visited}</small>
          <span className="mx-1 " style={{ color: "#f38e35" }}>
            <i class="bi bi-tags"></i>
          </span>
          <small className="mx-2">Uncategorized</small>
        </div>
        <div className="d-flex mx-1">
         
            <Link to={`/forum/${forum._id}`}
              className="btn"
              style={{ background: "#4DB7FE" }}
              
            >
              {" "}
              Read More
            </Link>
          
        </div>
      </div>
    </div>
  );
};

export default SingleForum;
